import Vue from 'vue'

const luLicenseType = {
  state: {
    luLicenseType: [],
    selectedLuLicenseType: {},
  },

  getters: {
    luLicenseType(state) {
      return state.luLicenseType
    },
    selectedLuLicenseType(state) {
      return state.selectedLuLicenseType
    },
  },

  mutations: {
    luLicenseType(state, payload) {
      state.luLicenseType = payload
    },
    selectedLuLicenseType(state, payload) {
      state.selectedLuLicenseType = JSON.parse(JSON.stringify(payload))
    },
  },

  actions: {
    setSelectedLuLicenseType(context, payload) {
      context.commit('selectedLuLicenseType', payload)
    },
    loadLuLicenseType(context, payload) {
      return new Promise((resolve, reject) => {
        const url = 'LuLicenseType'
        Vue.prototype.$axios.get(url).then(
          (res) => {
            context.commit('luLicenseType', res.data)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
    loadSelectedLuLicenseType(context, payload) {
      return new Promise((resolve, reject) => {
        const url = 'LuLicenseType/' + payload
        Vue.prototype.$axios.get(url).then(
          (res) => {
            context.commit('selectedLuLicenseType', res.data)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
    updateLuLicenseType(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `LuLicenseType/${payload.ID}`
        Vue.prototype.$axios.put(url, payload).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              {color: 'success', message: 'luLicenseType updated'},
              {root: true}
            )
            //if you will always need to reload the list after an update
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadLuLicenseType')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
    createLuLicenseType(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `LuLicenseType`
        Vue.prototype.$axios.post(url, payload).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              {color: 'success', message: 'luLicenseType created'},
              {root: true}
            )
            //if you will always need to reload the list after an item is created
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadLuLicenseType')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
    saveLuLicenseType(context, payload) {
      return new Promise((resolve, reject) => {
        if (payload.ID > 0) {
          context.dispatch('updateLuLicenseType', payload).then(
            (res) => resolve(res),
            (err) => reject(err)
          )
        } else {
          context.dispatch('createLuLicenseType', payload).then(
            (res) => resolve(res),
            (err) => reject(err)
          )
        }
      })
    },
    deleteLuLicenseType(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `LuLicenseType/${payload.ID}`
        Vue.prototype.$axios.delete(url).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              {color: 'success', message: 'luLicenseType deleted'},
              {root: true}
            )
            //if you will always need to reload the list after a delete
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadLuLicenseType')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
  },
}

export default luLicenseType
